"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tradeInFragment = void 0;
exports.tradeInFragment = `
  fragment tradeIn on TradeInVehicle {
    capital
    claimant
    debt
    id
    loan
    make
    mileage
    model
    price
    registrationNumber
  }
`;
//# sourceMappingURL=tradeIn.js.map